import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smoothly scrolls to the element matching the URL hash on mount and on
 * subsequent location changes. No-op when there's no hash.
 */
export default function useHashScroll() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      // Slight delay so the DOM finishes mounting before we scroll
      setTimeout(
        () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
        80,
      );
    }
  }, [location]);
}
